import { env } from '@/env';
import type {
  EliteCompanyListResponse,
  EliteCompanyPayload,
  NeedHelpRequest,
  RegisterRequest,
  SMSVerificationRequest
} from '@/models/interface/register';
import type { ApiDataResponse, ApiResponse } from '@/utils/api';
import type { ApiResponseModel } from '@/utils/api/models/api-response-model';
import axios, { AxiosError } from 'axios';

axios.interceptors.response.use(
  (response) => {
    if (response.data.status !== 200) {
    }
    return response;
  },
  (error) => {
    const e = error as AxiosError<ApiResponseModel<string>>;

    // 如果有 response，返回其 data，否則返回一個默認的錯誤信息
    if (e.response) {
      return e.response;
    } else {
      return Promise.reject({ message: 'An unknown error occurred' });
    }
  }
);
/**
 * 登入 API
 */
export class LoginService {
  private baseUrl = env.apiBaseUrl;
  /**
   * 發送簡訊驗證碼
   */
  smsVerification(userData: SMSVerificationRequest): Promise<ApiDataResponse<string>> {
    return axios.post<ApiResponseModel<string>>(
      `${this.baseUrl}/Auth/SimpleSMSVerification`,
      userData
    );
  }
  /**
   * 註冊
   */
  register(registData: RegisterRequest): Promise<ApiDataResponse<string>> {
    return axios.post(`${this.baseUrl}/Auth/SimpleRegister`, registData);
  }
  /**
   * 未收到驗證碼
   */
  needHelp(data: NeedHelpRequest): Promise<ApiResponse> {
    return axios.post(`${this.baseUrl}/Auth/NeedHelp?tel=${data.tel}`);
  }
  /**
   * 檢查信箱是否存在於上市上櫃清單
   * @param body - 上市上櫃信箱
   */
  checkEliteCompany(body: { email: string }): Promise<ApiDataResponse<boolean>> {
    return axios.post(`${this.baseUrl}/Auth/CheckCompanyEmail`, body);
  }
  /**
   * 取得上市上櫃公司清單
   */
  getEliteCompanyList(payload: EliteCompanyPayload): Promise<ApiDataResponse<EliteCompanyListResponse>> {
    return axios.get(`${this.baseUrl}/Auth/GetCompanyList`, { params: payload });
  }
}
